import styled from 'styled-components';

import { IconSchedule } from 'components/icons/schedule';
import { primitive } from 'styles/constants/primitives';
import { slideIn } from 'utils/style/animations';

export const CooldownWrapper = styled.div`
  position: sticky;
  inset-block-start: 0;
  width: 100%;
  height: 3.375rem;
  display: flex;
  flex-flow: row wrap;
  color: ${primitive.$white};
  font-size: 0.875rem;
  line-height: 0.875rem;
  background-color: ${Styles.color.alert.info.background};
  padding: 0.375rem;
  animation: ${slideIn} 0.4s 0.15s forwards;
  z-index: ${Styles.zIndex.top};
  path {
    fill: ${primitive.$white};
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: space-around;
  p {
    margin: 0;
    font-size: 0.75rem;
  }
`;

export const StyledIcon = styled(IconSchedule)`
  height: 1.5rem;
  margin: auto 0.375rem;
`;
